import { Environment, environment } from "app/environment/environment";
import { useForm } from "react-hook-form";

/**
 * Logs the errors during trigger() or handleSubmit()() if you are on development
 */
export const useFormVerbose: typeof useForm = (props) => {
  const isDevelopment = environment() === Environment.Development;
  const originalForm = useForm(props);
  return {
    ...originalForm,
    trigger: async () => {
      if (isDevelopment) {
        // eslint-disable-next-line no-console
        console.log("[DEV]:", originalForm.formState.errors);
      }

      const trigger = await originalForm.trigger();
      return trigger;
    },
    handleSubmit: (onValid, onInvalid) => {
      const onInvalidVerbose: typeof onInvalid = (errors, event) => {
        if (isDevelopment) {
          // eslint-disable-next-line no-console
          console.log("[DEV]:", errors);
        }

        return onInvalid?.(errors, event);
      };

      return originalForm.handleSubmit(onValid, onInvalidVerbose);
    },
  };
};
